import React from 'react'
import { EntryInMoreTab } from '@wmfe/sailor-ad-entry'
import { owlAddJsError, owlReportMetrics } from '@RootCommon/utils/owl'
import ErrorBoundary from '@RootCommon/components/ErrorBoundary'

export default function () {
  try {
    return <ErrorBoundary
      fallback={null}
      onError={(e) => {
        console.log(e, 'AD EntryInMoreTab error')
        owlAddJsError('AD EntryInMoreTab error', { e })
      }}
    >
      <EntryInMoreTab
        onVisibleChange={isShow => {
          console.log('EntryInMoreTab', 'isShow:', isShow)
          isShow && owlReportMetrics({
            AdEntryShow: 1,
          }, {
            entry: 'appMore',
            from: 'app',
          })
        }}
      />
    </ErrorBoundary>
  } catch (e) {
    console.log(e, 'AD EntryInMoreTab error catch')
    owlAddJsError('AD EntryInMoreTab error catch', { e })
    return null
  }
}
